import { MdOutlineArrowBackIosNew } from 'react-icons/md';

export default function Prev({
  children,
  iconColor,
  ...props
}: { children?: React.ReactNode } & React.HTMLAttributes<HTMLDivElement> & {
    iconColor?: string;
  }) {
  return (
    <div {...props} className="flex items-center gap-[4px]">
      <MdOutlineArrowBackIosNew color={iconColor} />
      <div>{children}</div>
    </div>
  );
}
